import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const logoHeaderDialogFn = /* @__PURE__ */ createRecipe('logo-header-dialog', {}, [])

const logoHeaderDialogVariantMap = {}

const logoHeaderDialogVariantKeys = Object.keys(logoHeaderDialogVariantMap)

export const logoHeaderDialog = /* @__PURE__ */ Object.assign(memo(logoHeaderDialogFn.recipeFn), {
  __recipe__: true,
  __name__: 'logoHeaderDialog',
  __getCompoundVariantCss__: logoHeaderDialogFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: logoHeaderDialogVariantKeys,
  variantMap: logoHeaderDialogVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, logoHeaderDialogVariantKeys)
  },
  getVariantProps: logoHeaderDialogFn.getVariantProps,
})